import _ from "lodash";
import { alarmTypes } from "./status";

function deviceAlarmType(item) {
	if (!item) return "";
	const alarm = alarmTypes.find(alarm => alarm.value === item.alarm_type);
	return _.get(alarm, "text", item.alarm_type);
}

function deviceAlarm(item) {
	return item.path.replace("Devices/", "").replaceAll("/", " ");
}

function valueText(item) {
	const type = alarmTypes.find(alarm => alarm.value === item.alarm_type) || {};
	let value = String(item.value);
	value = _.isNaN(Number(value))
		? `"${_.capitalize(value)}"`
		: _.round(value, 2);
	return `Current value is ${value}${type.unit || ""}`;
}

export default {
	deviceAlarm,
	deviceAlarmType,
	valueText,
};
